

export const filterDonors = (donors, filterValues) => {
  if (!Array.isArray(donors)) return [];

  return donors.filter((donor) => {
    const donorName = `${donor.firstName || ""} ${donor.lastName || ""}`.toLowerCase();
    const filterName = (filterValues.name || "").toLowerCase();
    const donorStatus = (donor.status || "").toLowerCase();

    // Normalize numbers: keep digits only
    const filterMobile = (filterValues.mobile || "").replace(/\D/g, "");
    const donorMobile1 = (donor.mobile1 || "").replace(/\D/g, "");
    const donorMobile2 = (donor.mobile2 || "").replace(/\D/g, "");

    // Apply mobile filter only if more than 3 digits entered
    const mobileFilterActive = filterMobile.length > 3;
    const mobileMatches = mobileFilterActive
      ? donorMobile1.includes(filterMobile) ||
        donorMobile2.includes(filterMobile)
      : true;

    return (
      (!filterValues.donorId ||
        Number(donor.donorId) === Number(filterValues.donorId)) &&
      (!filterValues.name || donorName.includes(filterName)) &&
      (!filterValues.pincode ||
        donor.pincode?.startsWith(filterValues.pincode)) &&
      (!filterValues.mobile || mobileMatches) &&
      (!filterValues.status?.length ||
        filterValues.status
          .map((s) => s.toLowerCase())
          .includes(donorStatus)) &&
      (!filterValues.remarks ||
        (donor.donorRemarks || "")
          .toLowerCase()
          .includes((filterValues.remarks || "").toLowerCase()))
    );
  });
};

// export  const filterDonors = (donors, filterValues) => {
//     if (!Array.isArray(donors)) return [];
//     return donors.filter((donor) => {
//       const donorName = `${donor.firstName || ""} ${
//         donor.lastName || ""
//       }`.toLowerCase();
//       const filterName = (filterValues.name || "").toLowerCase();
//       const donorStatus = (donor.status || "").toLowerCase();

//       // Helper to strip country code from mobile
//       const stripCountryCode = (mobile) => {
//         if (!mobile) return "";
//         // Remove +91 or any leading non-digit characters
//         return mobile.replace(/^\+?\d{0,2}/, "");
//       };

//       const filterMobile = (filterValues.mobile || "").replace(/\D/g, "");
//       const donorMobile1 = stripCountryCode(donor.mobile1 || "").replace(
//         /\D/g,
//         ""
//       );
//       const donorMobile2 = stripCountryCode(donor.mobile2 || "").replace(
//         /\D/g,
//         ""
//       );

//       // Only apply mobile filter if 3 or more digits are entered
//       // If less than 3 digits, ignore the mobile filter completely
//       const mobileFilterActive = filterMobile.length > 3;
//       const mobileMatches = mobileFilterActive
//         ? donorMobile1.includes(filterMobile) ||
//           donorMobile2.includes(filterMobile)
//         : true; // ignore mobile filter if less than 3 digits

//       return (
//         (!filterValues.donorId ||
//           Number(donor.donorId) === Number(filterValues.donorId)) &&
//         (!filterValues.name || donorName.includes(filterName)) &&
//         (!filterValues.pincode ||
//           donor.pincode?.startsWith(filterValues.pincode)) &&
//         (!filterValues.mobile || mobileMatches) &&
//         (!filterValues.status?.length ||
//           filterValues.status
//             .map((s) => s.toLowerCase())
//             .includes(donorStatus)) &&
//         (!filterValues.remarks ||
//           (donor.donorRemarks || "")
//             .toLowerCase()
//             .includes((filterValues.remarks || "").toLowerCase()))
//       );
//     });
//   };